import { render, staticRenderFns } from "./payrollDetail.vue?vue&type=template&id=56dad342&scoped=true&"
import script from "./payrollDetail.vue?vue&type=script&lang=js&"
export * from "./payrollDetail.vue?vue&type=script&lang=js&"
import style0 from "./payrollDetail.vue?vue&type=style&index=0&id=56dad342&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dad342",
  null
  
)

export default component.exports